import ReactDOM from 'react-dom/client';

import { App } from '@/app';

import '@/app/styles/index.css';

import { initializeAnalytics } from '@/shared/lib/analytics';
import { initSentry } from '@/shared/lib/sentry';

// Initialize Sentry before rendering the app (like in Flutter main.dart)
initSentry();

// Initialize RudderStack analytics
initializeAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
